
import styled from "styled-components";

export const Magic8BallMobileLandscapeWarningDefaultBox = styled.div`
    background-color: #000000;
    padding: 3rem;
`;
